import { useMutation, useQueryClient } from "@tanstack/react-query";

import { bffAxios } from "@av/config/api-config/axios-config";
import { COMPANY_DOCUMENTS_QUERY_KEY } from "../constants";

import type { CompanyDocumentView } from "../types";

export function useDeleteCompanyDocument() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (documentId: string) => {
      await bffAxios.delete(`/company-documents/${documentId}`);
    },
    onSuccess: (_data, documentId) => {
      queryClient.setQueriesData<CompanyDocumentView[]>(
        { queryKey: COMPANY_DOCUMENTS_QUERY_KEY },
        (documents) =>
          documents?.filter((document) => document.companyDocumentId !== documentId) ?? documents
      );

      void queryClient.invalidateQueries({ queryKey: COMPANY_DOCUMENTS_QUERY_KEY });
    },
  });
}
